var render = function render(){var _vm=this,_c=_vm._self._c;return _c('com-setting',{attrs:{"options":_vm.options,"value":_vm.value},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }